import { findFirstCruiseService } from '../filters';
import { isTariff } from '../guards';

import type { ProductWithServices, Tariff } from '../types';

export const getAvailableTariffs = (): Tariff[] => {
  return ['PUR', 'PLUS', 'PRO'];
};

export const getDefaultTariff = (): Tariff => 'PRO';

export const getTariffsFromProducts = (
  products: ProductWithServices[],
): Tariff[] => {
  return products.reduce<Tariff[]>((tariffs, product) => {
    const name = findFirstCruiseService(product)?.variant?.cabin.tariffType;

    if (!isTariff(name) || tariffs.includes(name)) {
      return tariffs;
    }

    return [...tariffs, name];
  }, []);
};
